import React from 'react';
import Layout from '../components/Layout';

const TermsPage = () => (
	<Layout>
		<div className="container light vertPadding">
			<h2>Terms of Use</h2>
			<p className="body-text">
				This Terms of Use describes the terms applicable to your use of the web sites, mobile-optimized versions
				of the web sites, and digital applications to which this Terms of Use is linked (collectively, "
				<strong>Covered Sites</strong>") and which are owned or operated by Hearst Communications, Inc. and its
				Affiliates (collectively, "<strong>Hearst</strong>") . As used in this Terms of Use, an entity
				controlling, controlled by, or under common control with another entity shall be deemed to be an "
				<strong>Affiliate</strong>", where control means ownership of 15% or more of the voting stock or other
				ownership interests. Certain features of the Covered Sites may be subject to additional guidelines,
				terms, or rules, which will be posted on the Covered Site in connection with such features. All such
				additional terms, guidelines, and rules are incorporated by reference into this Agreement. Capitalized
				terms not otherwise defined in this Agreement have the meaning given to such term in the Hearst{' '}
				<a
					rel="noreferrer"
					className="body-link"
					href="http://www.doctorozmag.com/privacy-policy"
					target="_blank"
				>
					privacy policy
				</a>
				. The privacy policy is hereby incorporated by this reference into this Agreement.
			</p>
			<p className="body-text">
				THESE TERMS OF USE ("<strong>AGREEMENT</strong>") SETS FORTH THE LEGALLY BINDING TERMS FOR YOUR USE OF
				THE COVERED SITES. BY ACCESSING OR USING THE COVERED SITES, YOU ARE ACCEPTING THIS AGREEMENT (ON BEHALF
				OF YOURSELF OR THE ENTITY THAT YOU REPRESENT) AND YOU REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT,
				AUTHORITY, AND CAPACITY TO ENTER INTO THIS AGREEMENT (ON BEHALF OF YOURSELF OR THE ENTITY THAT YOU
				REPRESENT). IF YOU DO NOT AGREE WITH ALL OF THE PROVISIONS OF THIS AGREEMENT, DO NOT ACCESS AND/OR USE
				THE COVERED SITES.
			</p>
			<p className="body-text">
				<strong>1. Username and Passwords. </strong>When you sign up to subscribe to our magazines, newsletters
				and other services you represent and warrant that: (a) all required information ("User Information") you
				submit is truthful and accurate; and (b) you will maintain the accuracy of such information. You will be
				responsible for maintaining the confidentiality of your user Information, and we will not be responsible
				for misuse of your information by any third party, whether authorized by you or not. You are responsible
				for all activities that occur under the accounts generated with your User Information. You agree to
				immediately notify Hearst of any unauthorized use, or suspected unauthorized use of your User
				Information or any other breach of security. Hearst cannot and will not be liable for any loss or damage
				arising from your failure to comply with the above requirements.
			</p>
			<p className="body-text">
				<strong>2. Licenses</strong>
			</p>
			<p className="sublist">
				<strong>2.1 License. </strong>Subject to the terms of this Agreement, Hearst grants you a
				non-transferable, non-exclusive, license to use the Covered Sites for your personal, noncommercial use.
				Subject to the terms of this Agreement, Hearst grants you a non-transferable, non-exclusive, license to
				install and use the software Hearst makes available for mobile devices ("
				<strong>Apps</strong>"), in executable object code format only, solely on your own handheld mobile
				device and for your personal, noncommercial use. For the avoidance of doubt, Apps are deemed part of the
				Covered Sites.
			</p>
			<p className="sublist">
				<strong>2.2 Certain Restrictions. </strong>The rights granted to you in this Agreement are subject to
				the following restrictions: (a) you shall not license, sell, rent, lease, transfer, assign, distribute,
				host, or otherwise commercially exploit the Covered Sites; (b) you shall not modify, make derivative
				works of, disassemble, reverse compile or reverse engineer any part of the Covered Sites; (c) you shall
				not access the Covered Sites in order to build a similar or competitive service; and (d) except as
				expressly stated herein, no part of the Covered Sites may be copied, reproduced, distributed,
				republished, downloaded, displayed, posted or transmitted in any form or by any means. Any future
				release, update, or other addition to functionality of the Covered Sites shall be subject to the terms
				of this Agreement. All copyright and other proprietary notices on any Covered Sites content must be
				retained on all copies thereof.
			</p>
			<p className="sublist">
				<strong>2.3 Open Source Software. </strong>
				Certain items of independent, third-party code may be included in the App that are subject to open
				source licenses ("
				<strong>Open Source Software</strong>"). Such Open Source Software is licensed under the terms of the
				license that accompanies such Open Source Software. Nothing in this Agreement limits your rights under,
				or grants you rights that supersede, the terms and conditions of any applicable end user license for
				such Open Source Software.
			</p>
			<p className="sublist">
				<strong>2.4 Application Store.</strong> You acknowledge and agree that the availability of the App is
				dependent on the third party from which you received the App, e.g., the Apple iPhone store ("
				<strong>Application Store</strong>"). You acknowledge that this Agreement is between you and Hearst and
				not with the Application Store. Each Application Store may have its own terms and conditions to which
				you must agree before downloading the App from it. You agree to comply with, and your license to use the
				App is conditioned upon your compliance with, all applicable terms and conditions of the applicable
				Application Store.
			</p>
			<p className="sublist">
				<strong>2.5 Wireless Addresses, Short Message Services and Wireless Internet. </strong>
				By providing us your wireless email address or by signing up for any SMS, WAP, or Mobile Service (each
				as described in the Privacy Policy), you agree to the following: Our wireless carriers and providers are
				not responsible for the content of our wireless services or any of the messages you may receive from us.
				You acknowledge and agree that the wireless email, SMS, WAP and Mobile Services are provided via
				wireless systems which use radios (and other means) to transmit communications over complex networks. We
				do not guarantee that your use of such services will be private or secure, and we are not liable to you
				for any lack of privacy or security you may experience. You are fully responsible for taking precautions
				and providing security measures best suited for your situation and intended use of the services.
			</p>
			<p className="sublist">
				<strong>2.6 Modification. </strong>Hearst reserves the right, at any time, to modify, suspend, or
				discontinue the Covered Sites or any part thereof with or without notice. You agree that Hearst will not
				be liable to you or to any third party for any modification, suspension, or discontinuance of the
				Covered Sites or any part thereof.
			</p>
			<p className="body-text">
				<strong>3. Ownership and Feedback</strong>
			</p>
			<p className="sublist">
				<strong>3.1 </strong>Excluding your User Content (defined below), you acknowledge that all the
				intellectual property rights, including copyrights, patents, trade marks, and trade secrets, in the
				Covered Sites are owned by Hearst or Hearst's licensors. The provision of the Covered Sites does not
				transfer to you or any third party any rights, title or interest in or to such intellectual property
				rights. Hearst and its suppliers reserve all rights not granted in this Agreement.
			</p>
			<p className="sublist">
				<strong>3.2 </strong>If you provide Hearst any feedback or suggestions regarding the Covered Sites ("
				<strong>Feedback</strong>"), you hereby assign to Hearst all rights in the Feedback and agree that
				Hearst shall have the right to use such Feedback and related information in any manner it deems
				appropriate. Hearst will treat any Feedback you provide to Hearst as non-confidential and
				non-proprietary. You agree that you will not submit to Hearst any information or ideas that you consider
				to be confidential or proprietary.
			</p>
			<p className="body-text">
				<strong>4. User Content</strong>
			</p>
			<p className="sublist">
				<strong>4.1 User Content.</strong> "
				<strong>User Content</strong>" means any and all information and content that a user submits to, or uses
				with, the Covered Sites (e.g., photos, audio, video, messages, text, files, or other content you provide
				us). You are solely responsible for your User Content. You assume all risks associated with use of your
				User Content, including any reliance on its accuracy, completeness or usefulness by others, or any
				disclosure of your User Content that makes you or any third party personally identifiable. You hereby
				represent and warrant that your User Content does not violate the Acceptable Use Policy (defined below).
				You may not state or imply that your User Content is in any way provided, sponsored or endorsed by
				Hearst. Because you alone are responsible for your User Content (and not Hearst), you may expose
				yourself to liability if, for example, your User Content violates the Acceptable Use Policy. Hearst is
				not obligated to backup any User Content and User Content may be deleted at anytime. You are solely
				responsible for creating backup copies of your User Content if you desire. Under no circumstance will
				Hearst be liable for any inaccuracy or defect in any User Content.
			</p>
			<p className="sublist">
				<strong>4.2 License.</strong> You hereby grant, and you represent and warrant that you have the right to
				grant, to Hearst an irrevocable, nonexclusive, royalty-free and fully paid, worldwide license to
				reproduce, distribute, publicly display and perform, prepare derivative works of, incorporate into other
				works, and otherwise use your User Content, and to grant sublicenses of the foregoing, for any lawful
				purpose. You agree to irrevocably waive (and cause to be waived) any claims and assertions of moral
				rights or attribution with respect to your User Content.
			</p>
			<p className="sublist">
				<strong>4.3 Acceptable Use Policy.</strong>The following sets forth Hearst's "
				<strong>Acceptable Use Policy</strong>":
				<strong>(a) </strong>You agree not to post, email, or otherwise make available User Content:
			</p>
			<ul className="body-ul">
				<li>
					that is unlawful, harmful, threatening, abusive, harassing, defamatory, pornographic, libelous, or
					invasive of another's privacy, or harmful to minors in any way;
				</li>
				<li>
					that harasses, degrades, intimidates or is hateful toward an individual or group of individuals on
					the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability;
				</li>
				<li>
					that includes personal or identifying information about another person without that person's
					explicit consent.
				</li>
				<li>
					that is false, deceptive, misleading, deceitful, misinformative, constitute "bait and switch" or
					impersonation of any person or entity;
				</li>
				<li>that contains your own or a third party's advertising, branding or promotional content;</li>
				<li>
					that is unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain
					letters, pyramid schemes, or any other form of duplicative or unsolicited messages, whether
					commercial or otherwise;
				</li>
				<li>
					that violates any third-party right, including any copyright, trademark, patent, trade secret, moral
					right, privacy right, right of publicity, or any other intellectual property or proprietary right;
				</li>
				<li>
					restrict or inhibit any other user from using and enjoying the Hearst sites or the Hearst services
					offered on them;
				</li>
				<li>
					that includes your personal information, such as telephone number, street address, last name, URL or
					email address;
				</li>
				<li>that is a "cut and paste" of private messages from other users;</li>
				<li>that re-broadcasts any User Content that violates these terms; or</li>
				<li>
					that is in violation of any law, regulation, or obligations or restrictions imposed by any third
					party.
				</li>
				<ol />
			</ul>
			<p className="body-text">
				<strong>(b) </strong>In addition, you agree not to use the Covered Sites to:
			</p>
			<ul className="body-ul">
				<li>
					upload, transmit, or distribute any computer viruses, worms, or any software intended to damage or
					alter a computer system or data;
				</li>
				<li>
					harvest, collect, gather or assemble information or data regarding other users, including e-mail
					addresses, without their consent;
				</li>
				<li>
					interfere with, disrupt, or create an undue burden on servers or networks connected to the Covered
					Sites or violate the regulations, policies or procedures of such networks;
				</li>
				<li>
					attempt to gain unauthorized access to the Covered Sites, other computer systems or networks
					connected to or used together with the Covered Sites, through password mining or other means;
				</li>
				<li>tamper with any copyright protection mechanisms applicable to content on any Covered Sites;</li>
				<li>
					introduce software or automated agents or scripts to the Covered Sites so as to produce multiple
					accounts, generate automated searches, requests and queries, or to strip, scrape, or mine data from
					the Covered Sites (except that we grant the operators of public search engines revocable permission
					to use spiders to copy materials from the Site for the sole purpose of and solely to the extent
					necessary for creating publicly available searchable indices of the materials, but not caches or
					archives of such materials).
				</li>
				<ol />
			</ul>
			<p className="body-text">
				<strong>4.4 Enforcement. </strong>We reserve the right (but have no obligation) to review any User
				Content, investigate, and/or take appropriate action against you in our sole discretion if you violate
				the Acceptable Use Policy or any other provision of this Agreement or otherwise create liability for us
				or any other person. Such acts may include removing or modifying your User Content, terminating your
				User Registration, and/or reporting you to law enforcement authorities. If Hearst elects to modify User
				Content, Hearst nonetheless assumes no responsibility for the User Content.
				<strong>4.5 Other Users. </strong>Each Covered Site user is solely responsible for any and all of its
				User Content. Because we do not control User Content, you acknowledge and agree that we are not
				responsible for any User Content and we make no guarantees regarding the accuracy, currency,
				suitability, or quality of any User Content, and we assume no responsibility for any User Content. Your
				interactions with other Covered Site users are solely between you and such user. You agree that Hearst
				will not be responsible for any loss or damage incurred as the result of any such interactions. If there
				is a dispute between you and any Covered Site user, we are under no obligation to become involved. You
				acknowledge that other users may post comments about your User Content which may be derogatory, and
				Hearst has no obligation to monitor or delete any such User Content.<strong>4.6 Release. </strong>You
				hereby release and forever discharge us (and our officers, employees, agents, successors, and assigns)
				from, and hereby waive and relinquish, each and every past, present and future dispute, claim,
				controversy, demand, right, obligation, liability, action and cause of action of every kind and nature
				(including personal injuries, death, and property damage), that has arisen or arises directly or
				indirectly out of, or relates directly or indirectly to, any interactions with, or act or omission of,
				other Covered Site users. IF YOU ARE A CALIFORNIA RESIDENT, YOU HEREBY WAIVE CALIFORNIA CIVIL CODE
				SECTION 1542 IN CONNECTION WITH THE FOREGOING, WHICH STATES: "A GENERAL RELEASE DOES NOT EXTEND TO
				CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING
				THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE
				DEBTOR."
				<strong>5. Indemnity. </strong>You agree to indemnify and hold Hearst (and its officers, employees,
				contractors, and agents) harmless, including costs and attorneys' fees, from any claim or demand made by
				any third party due to or arising out of (a) your use of the Covered Sites, (b) your User Content, (c)
				your violation of this Agreement; or (d) your violation of applicable laws or regulations. Hearst
				reserves the right, at your expense, to assume the exclusive defense and control of any matter for which
				you are required to indemnify us and you agree to cooperate with our defense of these claims. You agree
				not to settle any matter without the prior written consent of Hearst. Hearst will use reasonable efforts
				to notify you of any such claim, action or proceeding upon becoming aware of it.
			</p>
			<p className="body-text">
				<strong>6. Disclaimers</strong>
			</p>
			<p className="body-text">
				THE COVERED SITES ARE PROVIDED "AS-IS" AND "AS AVAILABLE" AND WE (AND OUR SUPPLIERS) EXPRESSLY DISCLAIM
				ANY WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING THE WARRANTIES OR
				CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, ACCURACY, OR
				NON-INFRINGEMENT. WE (AND OUR SUPPLIERS) MAKE NO WARRANTY THAT THE COVERED SITES: (A) WILL MEET YOUR
				REQUIREMENTS; (B) WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; OR (C)
				WILL BE ACCURATE, RELIABLE, FREE OF VIRUSES OR OTHER HARMFUL CODE, COMPLETE, LEGAL, OR SAFE.
			</p>
			<p className="body-text">
				DUE TO THE INHERENT NATURE OF THE INTERNET, WE CANNOT GUARANTEE THAT INFORMATION, DURING TRANSMISSION
				THROUGH THE INTERNET OR WHILE STORED ON OUR SYSTEM OR OTHERWISE IN OUR CARE, WILL BE ABSOLUTELY SAFE
				FROM INTRUSION BY OTHERS, SUCH AS HACKERS. HEARST ASSUMES NO LIABILITY FOR ANY ERROR, OMISSION,
				INTERRUPTION, DELETION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMMUNICATIONS LINE FAILURE, THEFT
				OR DESTRUCTION OR UNAUTHORIZED ACCESS TO, OR ALTERATION OF, ANY USER CONTENT. HEARST IS NOT RESPONSIBLE
				FOR ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ONLINE SYSTEMS,
				SERVERS OR PROVIDERS, COMPUTER EQUIPMENT, SOFTWARE, OR FAILURE OF ANY EMAIL DUE TO TECHNICAL PROBLEMS OR
				TRAFFIC CONGESTION ON THE INTERNET OR ON ANY OF THE COVERED SITES OR COMBINATION THEREOF, INCLUDING ANY
				INJURY OR DAMAGE TO USERS OR TO ANY PERSON'S COMPUTER RELATED TO OR RESULTING FROM PARTICIPATION IN ANY
				ACTIVITIES ON THE COVERED SITES OR DOWNLOADING MATERIALS. YOU UNDERSTAND THAT IF YOU DOWNLOAD ANY
				MATERIAL, YOU DO SO AT YOUR SOLE RISK. UNDER NO CIRCUMSTANCES SHALL HEARST BE RESPONSIBLE FOR ANY LOSS
				OR DAMAGE, INCLUDING PERSONAL INJURY OR DEATH, RESULTING FROM USE OF THE COVERED SITES, ANY CONTENT
				POSTED ON OR THROUGH THE COVERED SITES, OR CONDUCT OF ANY USERS OF THE COVERED SITES, WHETHER ONLINE OR
				OFFLINE. WE CAN, WHENEVER WE WANT, EDIT OR DELETE ANY CONTENT DISPLAYED ON THE COVERED SITES. YOU USE
				THE COVERED SITES AT YOUR OWN RISK. SOME AREAS OF OUR COVERED SITES OFFER ADVICE FROM A VARIETY OF
				PROVIDERS, WHO MAY BE AFFILIATED WITH HEARST OR MEMBER OF THE USER COMMUNITY; SUCH ADVICE IS FOR
				ENTERTAINMENT ONLY AND NOT AS TREATMENT OR REMEDY FOR AN INDIVIDUAL CIRCUMSTANCE. HEARST CANNOT
				GUARANTEE AND DOES NOT PROMISE ANY SPECIFIC RESULTS FROM USE OF THE COVERED SITES.
			</p>
			<p className="body-text">
				SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT
				APPLY TO YOU.
			</p>
			<p className="body-text">
				<strong>7. Limitation of Liability</strong>
			</p>
			<p className="body-text">
				IN NO EVENT SHALL WE (AND OUR SUPPLIERS) BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY LOST PROFIT OR ANY
				INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES ARISING FROM OR RELATING TO
				THIS AGREEMENT OR YOUR USE OF, OR INABILITY TO USE, THE COVERED SITES, EVEN IF WE HAVE BEEN ADVISED OF
				THE POSSIBILITY OF SUCH DAMAGES.
			</p>
			<p className="body-text">
				NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY DAMAGES ARISING
				FROM OR RELATED TO THIS AGREEMENT (FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION),
				WILL AT ALL TIMES BE LIMITED TO THE GREATER OF (A) FIFTY US DOLLARS ($50) OR (B) AMOUNTS YOU'VE PAID
				HEARST IN THE PRIOR 12 MONTHS (IF ANY). THE EXISTENCE OF MORE THAN ONE CLAIM WILL NOT ENLARGE THIS
				LIMIT. YOU AGREE THAT OUR SUPPLIERS WILL HAVE NO LIABILITY OF ANY KIND ARISING FROM OR RELATING TO THIS
				AGREEMENT.
			</p>
			<p className="body-text">
				SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OF CONSEQUENTIAL
				DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
			</p>
			<p className="body-text">
				<strong>8. Third Party Sites &amp; Ads. </strong>
				The Covered Sites might contain links to third party websites, services, and advertisements for third
				parties (collectively, "
				<strong>Third Party Sites &amp; Ads</strong>"). Such Third Party Sites &amp; Ads are not under the
				control of Hearst and Hearst is not responsible for any Third Party Sites &amp; Ads. Hearst provides
				these Third Party Sites &amp; Ads only as a convenience and does not review, approve, monitor, endorse,
				warrant, or make any representations with respect to Third Party Sites &amp; Ads. You use all Third
				Party Sites &amp; Ads at your own risk. When you link to a Third Party Site &amp; Ad, the applicable
				third party's terms and policies apply, including the third party's privacy and data gathering
				practices. You should make whatever investigation you feel necessary or appropriate before proceeding
				with any transaction in connection with such Third Party Sites &amp; Ads.
			</p>
			<p className="body-text">
				<strong>9. Term &amp; Termination. </strong>
				Subject to this Section, this Agreement will remain in full force and effect while you use the Covered
				Sites. We may (a) suspend your rights to use the Covered Sites (including your User Information) or (b)
				terminate this Agreement, at any time for any reason at our sole discretion, including for any use of
				the Covered Sites in violation of this Agreement. Upon termination of this Agreement, your User
				Information and right to access and use the Covered Sites will terminate immediately. You understand
				that any termination of your User Information involves deletion of your User Content associated
				therewith from our live databases. Hearst will not have any liability whatsoever to you for any
				termination of this Agreement, including for termination of your User Information or deletion of your
				User Content. Even after this Agreement is terminated, the following provisions of this Agreement will
				remain in effect: Sections 3 –11.
			</p>
			<p className="body-text">
				<strong>10. Copyright Policy</strong>
			</p>
			<p className="sublist">
				<strong>10.1 </strong>In accordance with the provisions of the Digital Millennium Copyright Act, 17 USC
				sec. 512, our Covered Sites have designated an agent to receive notices of claims of copyright
				infringement: Copyright Agent, Hearst Communications, Inc., Hearst Magazines Division, 300 West 57th
				Street – 40th floor, New York, New York, 10019, tel: 212-649-2020;{' '}
				<a rel="noreferrer" className="body-link" href="mailto:copyright@hearst.com">
					copyright@hearst.com
				</a>
				. If you believe your copyright has been infringed, you may provide us with notice. To be effective, the
				notification must be a written communication that includes the following:
			</p>
			<ul className="body-ul">
				<li>
					A physical or electronic signature of person authorized to act on behalf of the owner of an
					exclusive right that is allegedly infringed;
				</li>
				<li>
					Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted
					works at a single online site are covered by a single notification, a representative list of such
					works at that site;
				</li>
				<li>
					Identification of the material that is claimed to be infringing or to be the subject of infringing
					activity and that is to be removed or access to which is to be disabled, and information reasonably
					sufficient to permit us to locate the material;
				</li>
				<li>
					Information reasonably sufficient to permit us to contact you, including an address, telephone
					number, and, if available, an electronic mail address at which the complaining party may be
					contacted;
				</li>
				<li>
					A statement that the complaining party has a good-faith belief that use of the material in the
					manner complained of is not authorized by the copyright owner, its agent, or the law; and
				</li>
				<li>
					A statement that the information in the notification is accurate, and under penalty of perjury, that
					the complaining party is authorized to act on behalf of the owner of an exclusive right that is
					allegedly infringed.
				</li>
				<ol />
			</ul>
			<p className="body-text">
				We may give notice to our users that we have received a notice of infringement by means of a general
				notice on our site, electronic mail to a user's e-mail address in our records, or by written
				communication sent by first-class mail to a user's physical address in our records. If you receive such
				a notice, you may provide counter-notification in writing to the designated agent that includes the
				information below. To be effective, the counter-notification must be a written communication that
				includes the following:
			</p>
			<ul className="body-ul">
				<li>Your physical or electronic signature;</li>
				<li>
					Identification of the material that has been removed or to which access has been disabled, and the
					location at which the material appeared before it was removed or access to it was disabled;
				</li>
				<li>
					A statement from you under the penalty of perjury, that you have a good faith belief that the
					material was removed or disabled as a result of a mistake or misidentification of the material to be
					removed or disabled; and
				</li>
				<li>
					Your name, physical address and telephone number, and a statement that you consent to the
					jurisdiction of a Federal District Court for the judicial district in which your physical address is
					located, or if your physical address is outside of the United States, for the judicial district in
					which our offices are located, and that you will accept service of process from the person who
					provided notification of allegedly infringing material or an agent of such person.
				</li>
				<ol />
			</ul>
			<p className="body-text">
				If we become aware that any of our users has repeatedly infringed the proprietary rights of any third
				party, it is our policy to take steps to terminate that user's access to our Covered Sites.
			</p>
			<p className="body-text">
				<strong>11. General</strong>
			</p>
			<p className="sublist">
				<strong>11.1 Changes to Terms of Use. </strong>
				This Agreement is subject to occasional revision, and if we make any substantial changes, we may notify
				you by prominently posting notice of the changes on our Site. Any changes to this agreement will be
				effective upon the earlier of thirty (30) calendar days following our posting of notice of the changes
				on our Site. These changes will be effective immediately for new users of our Covered Sites. Continued
				use of our Covered Sites following notice of such changes shall indicate your acknowledgement of such
				changes and agreement to be bound by the terms and conditions of such changes.
			</p>
			<p className="sublist">
				<strong>11.2 Dispute Resolution. </strong>PLEASE READ THIS CAREFULLY. IT AFFECTS YOUR RIGHTS.
			</p>
			<ol className="body-ol">
				<li>
					Except for either party's claims of infringement or misappropriation of the other party's patent,
					copyright, trademark, or trade secret, any and all disputes between you and Hearst arising under or
					related in any way to this Agreement, must be resolved through binding arbitration as described in
					this section. This agreement to arbitrate is intended to be interpreted broadly. It includes, but is
					not limited to, all claims and disputes relating to your use of any of the Covered Sites.
				</li>
				<li>
					YOU AGREE THAT BY ENTERING INTO THIS AGREEMENT, YOU AND HEARST ARE EACH WAIVING THE RIGHT TO TRIAL
					BY JURY OR TO PARTICIPATE IN A CLASS ACTION. YOU AND HEARST AGREE THAT EACH MAY BRING CLAIMS AGAINST
					THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
					PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. ANY ARBITRATION WILL TAKE PLACE ON AN INDIVIDUAL
					BASIS; CLASS ARBITRATIONS AND CLASS ACTIONS ARE NOT PERMITTED.
				</li>
				<li>
					The arbitration will be governed by the Commercial Arbitration Rules and the Supplementary
					Procedures for Consumer Related Disputes of the American Arbitration Association ("<strong>AAA</strong>
					"), as modified by this section. For any claim where the total amount of the award sought is $10,000
					or less, the AAA, you and Hearst must abide by the following rules: (a) the arbitration shall be
					conducted solely based on written submissions; and (b) the arbitration shall not involve any
					personal appearance by the parties or witnesses unless otherwise mutually agreed by the parties. If
					the claim exceeds $10,000, the right to a hearing will be determined by the AAA rules, and the
					hearing (if any) must take place in your choice of the following locations: San Francisco, CA,
					Denver, CO, or New York, NY. The arbitrator's ruling is binding and may be entered as a judgment in
					any court of competent jurisdiction. In the event this agreement to arbitrate is held unenforceable
					by a court, then the disputes that would otherwise have been arbitrated shall be exclusively brought
					in the state or federal courts located in New York City, New York. Claims of infringement or
					misappropriation of the other party's patent, copyright, trademark, or trade secret shall be
					exclusively brought in the state and federal courts located in New York City, New York.
				</li>
				<li>
					This Agreement shall be governed by and construed solely and exclusively in accordance with the laws
					of the State of New York, USA without giving effect to any law that would result in the application
					of the law of another jurisdiction.
				</li>
				<ol />
			</ol>
			<p className="body-text">
				<strong>11.3 Entire Agreement. </strong>This Agreement (including the Privacy Policy) constitutes the
				entire agreement between you and us regarding the use of the Covered Sites. Our failure to exercise or
				enforce any right or provision of this Agreement shall not operate as a waiver of such right or
				provision. The section titles in this Agreement are for convenience only and have no legal or
				contractual effect. The word including means including without limitation. If any provision of this
				Agreement is, for any reason, held to be invalid or unenforceable, the other provisions of this
				Agreement will be unimpaired and the invalid or unenforceable provision will be deemed modified so that
				it is valid and enforceable to the maximum extent permitted by law. Your relationship to Hearst is that
				of an independent contractor, and neither party is an agent or partner of the other. This Agreement, and
				your rights and obligations herein, may not be assigned, subcontracted, delegated, or otherwise
				transferred by you without Hearst's prior written consent, and any attempted assignment, subcontract,
				delegation, or transfer in violation of the foregoing will be null and void. The terms of this Agreement
				shall be binding upon assignees.
			</p>
			<p className="body-text">
				<strong>11.4 Copyright/Trademark Information. </strong>
				Copyright © 2012, Hearst Communications, Inc. All rights reserved. All trademarks, logos and service
				marks ("
				<strong>Marks</strong>") displayed on the Covered Sites are our property or the property of other third
				parties. You are not permitted to use these Marks without our prior written consent or the consent of
				such third party which may own the Marks.
			</p>
			<p className="body-text">
				<strong>12. Apple App Store Additional Terms and Conditions.</strong>
				The following additional terms and conditions apply to you if you are using an App from the Apple App
				Store. To the extent the other terms and conditions of this Agreement are less restrictive than, or
				otherwise conflict with, the terms and conditions of this Section 12, the more restrictive or
				conflicting terms and conditions in this Section 12 apply, but solely with respect to Apps from the
				Apple App Store.
			</p>
			<p className="sublist">
				<strong>
					<br />
				</strong>
			</p>
			<p className="sublist">
				<strong>12.1 Acknowledgement:</strong> Hearst and you acknowledge that this Agreement is concluded
				between Hearst and you only, and not with Apple, and Hearst, not Apple, is solely responsible for App
				and the content thereof. To the extent this Agreement provides for usage rules for App that are less
				restrictive than the Usage Rules set forth for App in, or otherwise is in conflict with, the App Store
				Terms of Service, the more restrictive or conflicting Apple term applies.
			</p>
			<p className="sublist">
				<strong>12.2 Scope of License:</strong> The license granted to you for App is limited to a
				non-transferable license to use App on an iOS Product that you own or control and as permitted by the
				Usage Rules set forth in the App Store Terms of Service.
			</p>
			<p className="sublist">
				<strong>12.3 Maintenance and Support:</strong> Hearst is solely responsible for providing any
				maintenance and support services with respect to App, as specified in this Agreement (if any), or as
				required under applicable law. Hearst and you acknowledge that Apple has no obligation whatsoever to
				furnish any maintenance and support services with respect to App.
			</p>
			<p className="sublist">
				<strong>12.4 Warranty:</strong> Hearst is solely responsible for any product warranties, whether express
				or implied by law, to the extent not effectively disclaimed. In the event of any failure of App to
				conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price for
				App to you; and to the maximum extent permitted by applicable law, Apple will have no other warranty
				obligation whatsoever with respect to App, and any other claims, losses, liabilities, damages, costs or
				expenses attributable to any failure to conform to any warranty will be Hearst's sole responsibility.
			</p>
			<p className="sublist">
				<strong>12.5 Product Claims:</strong> Hearst and you acknowledge that Hearst, not Apple, is responsible
				for addressing any claims of you or any third party relating to App or your possession and/or use of
				App, including, but not limited to: (i) product liability claims; (ii) any claim that App fails to
				conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer
				protection or similar legislation. This Agreement does not limit Hearst's liability to you beyond what
				is permitted by applicable law.
			</p>
			<p className="sublist">
				<strong>12.6 Intellectual Property Rights:</strong> Hearst and you acknowledge that, in the event of any
				third party claim that App or your possession and use of App infringes that third party's intellectual
				property rights, Hearst, not Apple, will be solely responsible for the investigation, defense,
				settlement and discharge of any such intellectual property infringement claim.
			</p>
			<p className="sublist">
				<strong>12.7 Legal Compliance:</strong> You represent and warrant that (i) you are not located in a
				country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government
				as a "terrorist supporting" country; and (ii) you are not listed on any U.S. Government list of
				prohibited or restricted parties.
			</p>
			<p className="sublist">
				<strong>12.8 Developer Name and Address:</strong> Hearst's contact information for any end-user
				questions, complaints or claims with respect to App is: Hearst at 300 W. 57th Street, NY, NY 10019 or
				email digitalapps@hearst.com
			</p>
			<p className="sublist">
				<strong>12.9 Third Party Terms of Agreement: </strong>
				You must comply with applicable third party terms of agreement when using App.
			</p>
			<p className="sublist">
				<strong>12.10 Third Party Beneficiary:</strong> Hearst and you acknowledge and agree that Apple, and
				Apple's subsidiaries, are third party beneficiaries of this Agreement, and that, upon your acceptance of
				the terms and conditions of this Agreement, Apple will have the right (and will be deemed to have
				accepted the right) to enforce this Agreement against you as a third party beneficiary thereof.
			</p>
			<p className="sublist">
				<br />
				Last revised on: December 6, 2017
				<br />
			</p>
		</div>;
	</Layout>
);

export default TermsPage;
